import { IframeWindow } from '@ps/bridge/iframe/iframe.window.type'
import { specialNodes } from '@ps/bridge/qc/node/config'
import _ from 'lodash'
import { subtitle } from '@ps/workbench/layer/text/prefab'
import { generateUUID, parseComponent } from '@ps/utils/game'
import store from '@ps/store'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { EditorDataScript } from '@ps/bridge/qc/scripts/editor'
import * as languageScript from '@ps/bridge/qc/scripts/language'
import { cookPrefabBeforeAddInPlayable } from '@ps/workbench/layer/text'

/**
 * 添加临时文本节点
 */
export async function addTempTextNodes({
  iframeWindow,
  pid,
  uuid2url,
  textKeys
}: {
  iframeWindow: IframeWindow;
  pid: string;
  textKeys: string[];
  uuid2url: Record<string, string>;
}) {
  const { UIRoot } = iframeWindow
  const gamePlayNode = UIRoot.getChild(specialNodes.gamePlay.name)
  const nodes = []

  console.log(textKeys, '找不到对应的节点（可能是素材包制作时的异常数据或 pt 加工后产生的异常数据），为它们新增临时节点。')

  for (let i = 0; i < textKeys.length; i++) {
    const text = _.cloneDeep(subtitle)
    // @ts-ignore
    text.files = cookPrefabBeforeAddInPlayable(text.files)

    const component = parseComponent({
      data: text
    })

    const { node } = await store.dispatch(
      'workspace/game/prefab/addNewPrefab',
      {
        res: {
          name: component.prefabName,
          json: component.json,
          meta: component.meta,
          projectKey: pid,
          files: component.files,
          uuid2url,
          type: component.type,
          animationType: component.animationType // 用于识别龙骨类型的图集
        },
        // 添加到 gamePlay 节点下的第一个子节点，即第一个场景。这个场景是不能删除，所以可以将节点添加到这个场景中。
        scene: gamePlayNode.children[0],
        record: false,
        // 初始化样式
        // 将临时节点 visible 设置为 false，这样就不会再画布上看到了，这些临时节点在保存时会删掉
        style: {
          visible: false
        }
      }
    )
    // 生成一个唯一 id，避免与其他节点名字冲突
    node.name = generateUUID()
    console.log(`添加临时文本节点 oldLangKey = ${textKeys[i]}`, node, node.name, node.text)
    // 将临时节点 visible 设置为 false 与 x、y 设置 -10000，这样就不会再画布上看到了，这些临时节点在保存时会删掉
    node.visible = false
    node.x = -10000
    node.y = -10000
    const editorConfig = editorScript.getScript(node) as EditorDataScript
    editorConfig.$data.isTempNode = true
    // 存储原始 key
    editorConfig.$data.oldLangKey = textKeys[i]
    // 临时节点多语言配置中的 langKey 使用多语言配置中的的 key
    languageScript.updateLangKey(node, editorConfig.$data.oldLangKey)
    nodes.push(node)
  }
  return nodes
}

